import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import ValueCards from '../components/ValueCards';
import SocialProof from '../components/SocialProof';
import HowItWorks from '../components/HowItWorks';
import FlavorCircles from '../components/FlavorCircles';
import FunctionalShots from '../components/FunctionalShots';
import ComparisonTable from '../components/ComparisonTable';
import SpaSavingsCalculator from '../components/SpaSavingsCalculator';
import ShowroomTypes from '../components/ShowroomTypes';
import SplitSections from '../components/SplitSections';
import PricingStrip from '../components/PricingStrip';
import CustomerStories from '../components/CustomerStories';
import FAQ from '../components/FAQ';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
const HomePage = () => {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-970">
      <SEO title="SmartSoda | Premium Showroom Beverage Solutions | Enhance Customer Experience" description="Transform your showroom experience with SmartSoda's sustainable, premium beverage solutions. Increase customer dwell time, enhance sales conversations, and boost conversions with 29+ customizable options." keywords="SmartSoda, showroom experience, premium beverages, customer engagement, car dealership, furniture showroom, retail experience, sales conversion" data-id="element-971" />
      <Navbar data-id="element-972" />
      <main className="flex-grow" id="main-content" data-id="element-973">
        <Hero data-id="element-974" />
        <ValueCards data-id="element-975" />
        <SocialProof data-id="element-976" />
        <HowItWorks data-id="element-977" />
        <ShowroomTypes data-id="element-978" />
        <FlavorCircles data-id="element-979" />
        <FunctionalShots data-id="element-980" />
        <ComparisonTable data-id="element-981" />
        <SpaSavingsCalculator data-id="element-982" />
        <SplitSections data-id="element-983" />
        <PricingStrip data-id="element-984" />
        <CustomerStories data-id="element-985" />
        <FAQ data-id="element-986" />
        <CTASection data-id="element-987" />
      </main>
      <Footer data-id="element-988" />
    </div>;
};
export default HomePage;